import { FC } from "react";
import { ISvgProps } from "common/models/components/ui/ISvgProps";

export const SvgTransaction: FC<ISvgProps> = (props) => {
  return (
    <svg {...props} viewBox="0 0 122.88 122.88">
      <path
        fill="currentColor"
        d="M61.44,0A61.46,61.46,0,1,1,18,18,61.23,61.23,0,0,1,61.44,0ZM72.91,41.27a5.47,5.47,0,1,1,7.3-8.16L93.72,45.23A5.48,5.48,0,0,1,94.15,53l-.35.35h0l-13,12.12a5.48,5.48,0,0,1-7.47-8L76.1,54.8H62.39a5.5,5.5,0,0,1,0-11H75.75l-2.84-2.54Zm-30.5,16.1a5.47,5.47,0,1,1,7.3,8.16l-2.83,2.54H61.15a5.5,5.5,0,0,1,0,11H46.53l2.8,2.6a5.48,5.48,0,1,1-7.47,8l-13-12.11h0l-.35-.36a5.47,5.47,0,0,1,.42-7.73L42.41,57.37ZM96.86,26a50.08,50.08,0,1,0,14.68,35.43A49.95,49.95,0,0,0,96.86,26Z"
      />
    </svg>
  );
};
